import {Link} from 'react-router-dom';
import cn from 'classnames'

import {CollectionSelect} from '../../components/CollectionSelect/CollectionSelect';
import {CANDLES, DIFFUSER, DINNER, HANDLER, INTERIOR} from '../../config/routes';

import {Banner14Feb} from './Banners/Banner14Feb';
import aroma from './aroma.jpg'
import candles from './candles.jpg'
import dinner from './dinner.jpg'
import hadler from './hadler.jpg'
import interior from './interior.jpg'

import cls from './Index.module.scss'

export const Index = () => (
        <div className={cls.wrapper}>

            <Banner14Feb/>

            <CollectionSelect/>

            <div className={cls.menu}>
                <Link to={CANDLES} className={cn([cls.cardOne, cls.card])} style={{backgroundImage: `url(${candles})`}}>Ароматические<br/>свечи</Link>
                <Link to={HANDLER} className={cn([cls.cardTwo, cls.card])} style={{backgroundImage: `url(${hadler})`}}>Свечи<br/>в&nbsp;интерьерных
                    кашпо</Link>
                <Link to={DINNER} className={cn([cls.cardThree, cls.card])} style={{backgroundImage: `url(${dinner})`}}>Столовые<br/>свечи</Link>
                <Link to={INTERIOR} className={cn([cls.cardFour, cls.card])}
                      style={{backgroundImage: `url(${interior})`}}>Предметы<br/>интерьера</Link>
                <Link to={DIFFUSER} className={cn([cls.cardFive, cls.card])}
                      style={{backgroundImage: `url(${aroma})`}}>Арома-<br/>диффузоры</Link>
            </div>

        </div>
    )